<div class="ns-progress">
	<svg class="ns-progress__svg" [attr.width]="width" [attr.height]="height" viewBox="0 0 120 120">
		<circle class="ns-progress__meter" cx="60" cy="60" [attr.r]="radius"  [attr.stroke-width]="strokeWidth"/>
		<circle [ngClass]=" circleClassName" [style.strokeDasharray]="circumference"
			[style.strokeDashoffset]="dashoffset" cx="60" cy="60" [attr.r]="radius" [attr.stroke-width]="strokeWidth"
			stroke-linecap="square" />
	</svg>
</div>
